import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import "./header.css";

const Header = () => {
  const [Toggle, showMenu] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const savedDarkMode = localStorage.getItem('darkMode');
    // Jika tidak ada preferensi di localStorage, default ke dark mode (true)
    return savedDarkMode !== null ? JSON.parse(savedDarkMode) : true;
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  return (
    <header className="header">
      <nav className="nav container">
        <NavLink to="/" className="nav__logo" onClick={() => showMenu(false)}>Odiq</NavLink>
        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <NavLink
                to="/"
                end
                className={({ isActive }) => "nav__link" + (isActive ? " active-link" : "")}
                onClick={() => showMenu(false)}
              >
                <i className="uil uil-estate nav__icon"></i>
                Home
              </NavLink>
            </li>
            <li className="nav__item">
              <NavLink
                to="/about"
                className={({ isActive }) => "nav__link" + (isActive ? " active-link" : "")}
                onClick={() => showMenu(false)}
              >
                <i className="uil uil-user nav__icon"></i>
                About
              </NavLink>
            </li>
            {/* Tombol toggle dark mode */}
            <li className="nav__item nav__item--theme">
              <button
                className="theme-switch"
                onClick={() => setDarkMode(!darkMode)}
                aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
              >
                <span className={"theme-switch__option" + (!darkMode ? " theme-switch__option--active" : "")}>
                  <FontAwesomeIcon icon={faSun} />
                </span>
                <span className={"theme-switch__option" + (darkMode ? " theme-switch__option--active" : "")}>
                  <FontAwesomeIcon icon={faMoon} />
                </span>
              </button>
            </li>
          </ul>
          <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>
        </div>

        <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;